<vi-program-item
  *ngIf="flowLimitTemperature$ | async | ready as feature"
  [displayProgramTile]="false"
>
  <div item class="flow-limit-temp-wrapper" *ngIf="feature | executable: 'setMax'">
    <app-temperature-select
      *ngIf="onCancelFlowLimitTemperature$ | async"
      class="max-flow-temp-limit"
      data-at-flow-limit-temperature
      [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.LABEL' | translate"
      [rangeDefinition]="feature | constraints: 'setMax':'temperature'"
      [value]="feature?.properties?.max?.value"
      (valueChange)="
        onLimitFlowTempChange($event, feature.feature, feature.properties['max'].value)
      "
    ></app-temperature-select>
    <!-- this second app-temperature-select is a hacky way to refresh control when user presses cancel on modal without ugly white flickering -->
    <app-temperature-select
      *ngIf="!(onCancelFlowLimitTemperature$ | async)"
      class="max-flow-temp-limit"
      data-at-flow-limit-temperature
      [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.LABEL' | translate"
      [rangeDefinition]="feature | constraints: 'setMax':'temperature'"
      [value]="feature?.properties?.max?.value"
      matTooltip="{{
        '+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.TOOLTIP' | translate
      }}"
      matTooltipPosition="above"
      (valueChange)="
        onLimitFlowTempChange($event, feature.feature, feature.properties['max'].value)
      "
    ></app-temperature-select>
  </div>
  <vi-item
    item
    *ngIf="!(feature | executable: 'setMax')"
    [title]="'+INSTALLATIONS.INSTALLATION.CIRCUIT.FLOW_LIMIT_TEMPERATURE.LABEL' | translate"
    value="{{ feature | value2: featurePropertyKey.max }} {{
      feature | unit: featurePropertyKey.max
    }}"
  ></vi-item>
</vi-program-item>
